<template>
  <div class="preferred-delivery-methods">
    <div class="preferred-delivery-methods__container">
      <h3 class="preferred-delivery-methods__title">
        {{ t('preferredDeliveryMethodTitle') }}
      </h3>

      <div class="preferred-delivery-methods__accordion">
        <oie-base-button :text="t('deliveryInformationToggleButtonLabel')" css-classes="button--icon-right button--true-ghost" @click="() => isExpanded = !isExpanded">
          <template v-slot:icon>
            <oie-use-svg svg="chevron-down" :class="{ 'is-expanded': isExpanded }"></oie-use-svg>
          </template>
        </oie-base-button>
        <div v-if="isExpanded" class="accordion__content">
          <div v-for="info in deliveryInformation" :key="info.title" class="accordion__content-item">
            <h4>{{ info.title }}</h4>
            <p>{{ info.description }}</p>
          </div>
        </div>
      </div>

      <div class="preferred-delivery-methods__radio-buttons">
        <oie-base-radio
          v-for="method in deliveryMethods"
          :id="`${method.id}_i`"
          :key="method.id"
          :value="method.id"
          :is-checked="selectedMethod === method.id"
          :label-text="`${method.title} ${method.subTitle}`"
          :use-sub-text="true"
          :disabled="!editable"
          css-classes="radio--blue"
          name="shipping-type"
          @change="onChange"
          @click="onClick">
          <span class="radio__label-sub-text-container">
            {{ method.descriptionCaption }} {{ method.descriptionText }}

            <!-- <span class="radio__label-sub-text-price">
              {{ method.useShippingAgreement ? 0 : `${method.price} ${method.currency}` }}
            </span> -->
          </span>
        </oie-base-radio>
      </div>

      <div v-if="editable" class="preferred-delivery-methods__bottom">
        <oie-base-button
          css-classes="button--blue"
          :text="tStatic('genericSave')"
          @click="save"></oie-base-button>
        <oie-base-button class="button--no-background" :text="tStatic('modalCancel')" @click="cancel"></oie-base-button>
      </div>
    </div>

    <oie-base-button
      :text="t('changePreferredDeliveryMethod')"
      :disabled="editable"
      css-classes="button--icon-left button--true-ghost preferred-delivery-methods__change-button"
      @click="editDeliveryMethod">
      <template v-slot:icon>
        <oie-use-svg svg="edit-list"></oie-use-svg>
      </template>
    </oie-base-button>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    deliveryMethods: [],
    deliveryInformation: [],
    selectedMethod: {},
    oldMethod: {},
    editable: false,
    isExpanded: false
  }),
  mounted() {
    this.getDeliveryMethods()
    this.getPreferredDeliveryMethod()
  },
  methods: {
    ...mapActions('checkout', ['clearCheckout']),
    getDeliveryMethods() {
      httpService.get('auth/deliveryMethods').then((res) => {
        this.deliveryMethods = res.data.deliveryMethods
        this.deliveryInformation = res.data.deliveryInformation
      })
    },
    getPreferredDeliveryMethod() {
      httpService.get('auth/preferredDeliveryMethod').then(res => {
        this.selectedMethod = res.data.methodId
      })
    },
    editDeliveryMethod() {
      this.editable = true
      this.oldDelivery = this.selectedMethod
    },
    cancel() {
      this.editable = false
      this.selectedMethod = this.oldDelivery
    },
    save() {
      this.editable = false
      httpService.patch('auth/deliveryMethods', { methodId: this.selectedMethod }).then(() => {
        this.clearCheckout()
      })
    },
    onChange(value) {
      // if (this.selectedMethod === value) {
      //   this.selectedMethod = ''
      // } else {
      //   this.selectedMethod = value
      // }
    },
    onClick(id) {
      if (this.selectedMethod === id) {
        this.selectedMethod = ''
      } else {
        this.selectedMethod = id
      }
    }
  }
}
</script>

<style lang="scss">
.preferred-delivery-methods {
  margin-top: 2.5rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 0 2rem;
  align-items: flex-start;
}

.preferred-delivery-methods__container {
  max-width: 400px;

  h3 {
    @include h3-semi-bold;
    line-height: 1.5rem;
    margin: 0 0 1.5rem 0;
    color: color(gray-1);
  }
}

.preferred-delivery-methods__accordion {
  margin-bottom: 1.5rem;

  .button {
    align-items: center;
    padding: 0;
    @include body-smaller;
    line-height: 1.3125rem;
    height: auto;
    color: color(gray-1);

    svg {
      order: 1;
      margin-top: 2px;

      &.is-expanded {
        transform: rotate(-90deg);
      }
    }
  }

  .accordion__content {
    max-width: 800px;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1.5rem;

    h4 {
      margin: 0;
      @include body-smaller-semi-bold;
      color: #000000;
    }

    p {
      margin: 0;
      @include body-smaller;
      color: #000000;
    }
  }
}

.preferred-delivery-methods__radio-buttons {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2.5rem
}

.preferred-delivery-methods .radio {
  overflow: visible;
}

.preferred-delivery-methods .radio__label {
  padding-left: 50px;
  overflow: visible;

  &::before {
    position: absolute;
    left: 0;
    top: -3px;
    margin: 0;
  }

  &::after {
    top: 12px;
  }
}

.preferred-delivery-methods__bottom {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.preferred-delivery-methods__change-button {
  @include body-semi-bold;
  color: #fff;

  &:disabled {
    display: none;
  }

  svg {
    display: none;
  }
}

@include media(to-small) {
  .preferred-delivery-methods__change-button,
  .preferred-delivery-methods__bottom > .button--blue {
    box-shadow: none;
    background-color: color(brand-blue-3);
  }
}

@include media(small) {
  .preferred-delivery-methods {
    flex-direction: row;
  }

  .preferred-delivery-methods__accordion {
    margin-bottom: 2.5rem;
  }

  .preferred-delivery-methods__radio-buttons {
    margin-bottom: 2rem;
  }

  .preferred-delivery-methods__bottom {
    gap: 1.5rem;
  }

  .preferred-delivery-methods__change-button {
    color: color(brand-blue-3);
    height: auto;

    &:disabled {
      display: flex;
    }

    svg {
      display: inline-block;
    }
  }
}

</style>
